import { useEffect, useState } from "react";
import Order from "../APIController/Order";
import { useNavigate } from "react-router-dom";

const PaymentValidator = () => {
    const navigate = useNavigate();
    const [status, ] = useState("Prüfe Zahlung...");
    const { validatePayment } = Order()

    useEffect(() => {
        validateAndBroadcast()
    }, []);

    const validateAndBroadcast = async () => {
        const params = new URLSearchParams(window.location.search);
        const redirectStatus = params.get("redirect_status");
        const deviceId = params.get("deviceId")
        await validatePayment(deviceId, redirectStatus)
        navigate(`app/payment?deviceId=${deviceId}`)
    }

    return <h2>{status}</h2>;
};

export default PaymentValidator;